// ADD YOUR OWN GOOGLE MAPS API KEY HERE
export const API_KEY = 'AIzaSyAWEbEiNYw0VLXvFKeFUho6ObHPnZ4zEd4'
